import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { DesktopDeviationSharePopup } from '../../../SharePopup';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
var ShareButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.share'), renderPopover: function () { return React.createElement(DesktopDeviationSharePopup, { deviation: deviation }); } },
        React.createElement(ActionBarToggleButton, { icon: ShareIcon, biData: BiData({
                evid: 355,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                deviationid: deviation.deviationId,
            }), onClick: function () {
                if (!isMobile) {
                    return;
                }
                onClick(deviation);
            }, "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON })));
};
ShareButton.displayName = 'ShareButton';
export default ShareButton;
//# sourceMappingURL=ShareButton.js.map